'use client';

import { ReactNode } from 'react';
import { Paper, Container, SxProps, Theme, Box } from '@mui/material';

import styles from '@/styles/modules/Auth.module.css';

export const defaultStyles = {
    width: ['100%', '85%', '65%'],
    p: [3, '5% 15%'],
    my: [3, 6],
    mx: 'auto',
    position: 'relative',
} as SxProps<Theme>;

export const navigationContentStyles = {
    position: 'absolute',
    height: '40px',
    overflow: 'hidden',
    top: 0,
    left: 0,
    mt: -5,
};

export const CenteredContentWrapper = ({
    children,
    navigationContent,
    customStyles,
}: {
    children: ReactNode;
    navigationContent?: ReactNode;
    customStyles?: typeof defaultStyles;
}) => (
    <Container>
        <Paper sx={customStyles ?? defaultStyles} className={styles.container}>
            {navigationContent && <Box sx={navigationContentStyles}>{navigationContent}</Box>}
            {children}
        </Paper>
    </Container>
);
